
import { doc, updateDoc, increment, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export async function incrementGenerationUsage(userId: string) {
  const userRef = doc(db, 'users', userId);
  try {
    await updateDoc(userRef, {
      generationsUsed: increment(1)
    });
  } catch (error) {
    console.error("Failed to increment generation usage:", error);
    // If user doc doesn't have the field yet, we might need a setDoc or check
    const snap = await getDoc(userRef);
    if (snap.exists() && snap.data().generationsUsed === undefined) {
      await updateDoc(userRef, { generationsUsed: 1 });
    }
  }
}
